<template>
    <a-sub-menu :key="item.path">
        <template v-slot:title>
            <span class="anticon">
                <Vicon :icon="item.meta.icon"></Vicon>
            </span>
            <span>{{ item.meta.title }}</span>
            
        </template>
        <slot></slot>
        <!-- <MenuItem :routeChildren="routeChildren"/> -->
    </a-sub-menu>
</template>

<script>
import { defineComponent, ref, reactive, toRefs, onBeforeMount, onMounted, watchEffect, computed } from 'vue';
import Vicon from '../icon/index.vue'
import MenuItem from './MenuItem.vue';

export default defineComponent({
    name:'Submenu',
    components:{Vicon,MenuItem},
    props:{
        item: {
            type: Object,
            default() {
                return null
            },
        },
        routeChildren: {
            type: Object,
            default() {
                return null
            },
        },
    },
    setup(props){
    }
})
</script>
<style scoped lang='less'>
</style>